import type { ReactNode } from "react";

import type { User } from "../../../../models/User";
import type { WPApiBlock } from "../../../../models/WPContentBlock";
import type { WPProductConfig } from "../../../../models/WPProductConfig";
import type { ApiClient } from "../../../../utils/api/_makeApiClient";

export async function fetchStudentActiveTests(
  apiClient: ApiClient,
  user: User | undefined,
  product: WPProductConfig | undefined,
  block: WPApiBlock,
): Promise<ReactNode | null> {
  if (!user || !product) {
    return null;
  }

  const [tests, { StudentActiveTests }] = await Promise.all([
    apiClient.fetchStudentActiveTests(user, product),
    import("../../../components/blocks/StudentActiveTests/StudentActiveTests"),
  ]);

  return <StudentActiveTests model={block} tests={tests} />;
}
